import moment from "moment";

export default function ModelExamStatus({ course, currentDate, tenAM }) {
  // Convert course dates to moment objects
  const startDate = moment(course.started_dt);
  const endDate = moment(course.end_dt);
  const apply_last_date = moment(course.apply_last_date);


  return (
    <>
      {/* {currentDate.isBetween(
        startDate,
        endDate,
        "day",
        "[]" // Include the end date
      ) && currentDate.isAfter(tenAM) ? (
        <td id="td">
          <span className="GreenTexts">OnGoing</span>
        </td>
      ) : apply_last_date.isAfter(startDate) ||
        (currentDate.isSame(startDate, "day") &&
          currentDate.isBefore(tenAM)) ? (
        <td id="td">
          <span className="PinkText">Upcoming</span>
        </td>
      ) : (
        <td id="td">
          <span className="GreyText">Completed</span>
        </td>
      )} */}

      {
        apply_last_date.isAfter(currentDate) || startDate.isAfter(currentDate) ? (
        <td id="td">
          <span className="PinkText">Upcoming</span>
        </td>) :  currentDate.isBetween(
              startDate,
              endDate,
              "day",
              "[]" // Include the end date
            ) && apply_last_date.isSame(currentDate, "day") ? (
              <td id="td">
                <span className="GreenTexts">OnGoing</span>
              </td>
            ) :
            (
              <td id="td">
              <span className="GreyText">Completed</span>
            </td>
            )
      }
    </>
  );
}
